import EficienciaFisicaModal from "./EficienciaFisicaModal";
export default EficienciaFisicaModal;